<template>
  <div class="LocalOcorrencia mb-2">
    <div class="LocalOcorrencia_header mb-3">
      <div class="row no-gutters align-items-center justify-content-between">
        <div class="col">
          <h2 class="LocalOcorrencia_header_title">
            Local Ocorrência
          </h2>
        </div>
      </div>
    </div>

    <div v-if="!propLegado"
         class="px-2 mt-2">
      <div class="row">
        <div class="col-12 col-md-4 col-sm-5">
          <div class="form-group">
            <label class="label"
                   for="decNascidoVivo">Nº Declaração Nascido Vivo</label>
            <input id="decNascidoVivo"
                   v-model="numDeclaracaoNascidoVido"
                   v-mask="['99999999', '99-99999999-9']"
                   v-validate="{ regex: /^\d{2}-\d{8}-\d$|^\d{11}|^\d{8}$/ }"
                   data-vv-validate-on="custom|blur"
                   :class="{ 'is-invalid': errors.has('decNascidoVivo') }"
                   class="form-control form-control-sm"
                   maxlength="13"
                   name="decNascidoVivo"
                   placeholder="00‐00000000‐0"
                   type="text"
                   @change="checkDnv">
            <small v-if="errors.has('decNascidoVivo')"
                   class="invalid-feedback">{{ errors.first('decNascidoVivo') }}</small>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!noAddButton && !Object.entries(local).length">
      <button v-b-modal="`addLocalOcorrencia_${_uid}`"
              class="btn btn-sm btn-outline-primary btn-block btn-add-local"
              @click="modalAdd = true">
        <icon-svg icon="add"
                  class="icon-add mr-1" />
        Adicionar local de ocorrência
      </button>
    </div>

    <div v-if="modalAdd">
      <FormLocalOcorrencia :hide-search="!!(local && (local.descricao || local.tipo) || local && (['IGNORADO', 'ignorado', 'FORA_UNIDADE_SAUDE'].indexOf(local.tipo) != -1))"
                           :edit="toEditLocalOcorrencia"
                           :dados="local"
                           :prop-cartorio="propCartorio"
                           :prop-correcoes="propCorrecoes"
                           :prop-lista-hospitais="listaHospitais"
                           @addOcorrencia="receiveOcorrencia"
                           @clearData="clearOcorrencia"
                           @deleteError="deleteError" />
    </div>

    <BoxLocalOcorrencia v-if="local && Object.entries(local).length"
                        :dados="local">
      <slot>
        <button type="button"
                class="btn btn-sm btn-danger mr-2"
                @click="removeOcorrencia">
          Remover
        </button>

        <button class="btn btn-sm btn-primary"
                :disabled="local.tipo == 'IGNORADO'"
                type="button"
                @click="editOcorrencia">
          Editar
        </button>
      </slot>
    </BoxLocalOcorrencia>
  </div>
</template>

<script>
  /* componetns */
  import FormLocalOcorrencia from '@/components/SofiaRei/Nascimento/FormLocalOcorrencia.vue'
  import BoxLocalOcorrencia from '@/components/SofiaRei/Nascimento/BoxLocalOcorrencia'

  /* services */
  import HospitaisService from "@/services/HospitaisService"
  import ValidateDeclarationService from "@/services/Registros/ValidateDeclarationService"

  /* libraries */
  import {mapGetters} from "vuex"
  import moment from "moment"

  export default {
    name: 'LocalOcorrencia',
    components: {
      FormLocalOcorrencia,
      BoxLocalOcorrencia
    },
    props: {
      noAddButton: Boolean,
      numDnv: { type: String, default: () => '' },
      numDnvCadastrada: { type: String, default: () => '' },
      local: { type: Object, default: () => {} },
      propCartorio: { type: Object, default: () => { return {} } },
      propCorrecoes: { type: Object, default: () => { return {} } },
      propRascunho: { type: Boolean, default: () => false },
      propLegado: { type: Boolean, default: () => false },
      propBirthYear: { type: String, default: () => '' }
    },
    data () {
      return {
        numDeclaracaoNascidoVido: '',
        modalAdd: false,
        toEditLocalOcorrencia: {},
        listaHospitais: []
      }
    },
    computed: {
      ...mapGetters({
        cartorioId: 'auth/getCartorioId'
      })
    },
    watch: {
      numDnv () {
        this.numDeclaracaoNascidoVido = this.numDnv
      },
      propBirthYear () {
        this.checkDnv()
      }
    },
    mounted () {
      this.numDeclaracaoNascidoVido = this.numDnv
    },
    methods: {
      async checkDnv () {
        const birthYear = moment(this.propBirthYear).format("YYYY")
        let DNV = this.numDeclaracaoNascidoVido ? this.numDeclaracaoNascidoVido.replace(/[-]/ig, '') : ''

        if (DNV.length == 0) {
          this.$emit('numDeclaracaoUpdated', DNV)
          return
        }

        //43700000 é a numeração maxima da promeira versão do DNV
        if (DNV.length === 8 && DNV > 43700000) return displayMessage('error', 'Erro!', `D.N.V Número ${DNV} não é válida, numeração superior ao limite da versão`)

        // caso o ano seja 2006 deve aceitar ambas as versões de DNV
        if (DNV.length === 8 && birthYear >= 2007) { // Não aceita DNV com 8 digitos depois de 2007
          DNV = ''
          this.numDeclaracaoNascidoVido = DNV
          this.$emit('numDeclaracaoUpdated', DNV)
          return displayMessage('error', 'Erro!', `D.N.V Número ${DNV} não é válida para o ano informado`)
        }
        if (DNV.length === 11 && birthYear <= 2005) { // Não aceita DNV com 11 digitos antes de 2005
          DNV = ''
          this.numDeclaracaoNascidoVido = DNV
          this.$emit('numDeclaracaoUpdated', DNV)
          return displayMessage('error', 'Erro!', `D.N.V Número ${DNV} não é válida para o ano informado`)
        }

        if (!this.propRascunho && DNV === this.numDnvCadastrada) {
          this.numDeclaracaoNascidoVido = DNV
          return
        }

        try {
          loader({ text: 'Validando DNV', active: true })
          const valid = await ValidateDeclarationService.validateDnv(DNV, null, birthYear)
          if (valid) {
            this.numDeclaracaoNascidoVido = DNV
          }
        } catch (e) {
          objSwal.error.title = ''
          objSwal.error.text = e.response.data && e.response.data.message ? e.response.data.message : `D.N.V Número ${DNV} não é válida`
          objSwal.error.html = ''

          this.numDeclaracaoNascidoVido = null

          Swal.fire(objSwal.error)
        } finally {
          this.$emit('numDeclaracaoUpdated', this.numDeclaracaoNascidoVido)
          loader({ text: '', active: false })
        }
      },
      clearOcorrencia () {
        this.toEditLocalOcorrencia = {}
        this.$emit('clearEditOcorrencia', this.toEditLocalOcorrencia)

        this.modalAdd = false
      },
      receiveOcorrencia (val) {
        const local = {...val}

        if ((val.hospital && val.hospital.hospital_id) || val.hospital_id) {
          local.tipo = "UNIDADE_SAUDE"
          local.descricao = val.descricao || val.nome
          local.sub_tipo = 'hospital'
        }

        switch (val.tipo) {
        case 'domicilio':
          local.descricao = null
          local.tipo = "FORA_UNIDADE_SAUDE"
          local.sub_tipo = val.tipo
          break

        case 'ignorado':
          local.descricao = null
          local.tipo = "IGNORADO"
          local.sub_tipo = val.tipo
          break

        case 'outros estabelecimentos de saude':
          local.descricao = val.descricao || val.nome
          local.tipo = "UNIDADE_SAUDE"
          local.sub_tipo = val.tipo
          break

        case 'outros':
          local.descricao = null
          local.tipo = 'FORA_UNIDADE_SAUDE'
          local.sub_tipo = val.tipo
          break
        }

        // Caso a ocorrência recebida seja uma edição, de um local pré cadastrado de um rascunho
        if (this.toEditLocalOcorrencia && this.propRascunho) {
          // Deletamos os endereco_id para adicionar um novo endereço corretamente
          delete local.endereco_id
          delete local.endereco.endereco_id

          this.toEditLocalOcorrencia = local
        }

        this.$emit('receiveOcorrencia', local)

        this.modalAdd = false
      },
      removeOcorrencia () {
        this.$emit('removeOcorrencia')
      },
      async editOcorrencia () {
        this.modalAdd = true
        this.toEditLocalOcorrencia = { ...this.local }

        if (this.toEditLocalOcorrencia.tipo == 'UNIDADE_SAUDE') {
          const payload = {
            cartorio_id: this.$store.state.auth.cartorio_id,
            nome: this.toEditLocalOcorrencia.descricao,
            ativo: 1,
          }

          try {
            const result = await HospitaisService.getHospitais(payload)

            this.listaHospitais = result.data

          } catch (error) {
            console.error(error)
          }
        }
      },
      deleteError (erros) {
        this.$emit('deleteError', erros)
      }
    }
  }
</script>

<style lang="scss">
  @import '@/scss/_utilities/_exports';

  .LocalOcorrencia {
    &_header {
      @extend %titleBox;
      background-color: $color-gray-light;

      &_error {
        color: #8B0000
      }

      &_title {
        @extend %titleBox_title;
      }
    }
  }

  .iconAddLocal {
    width: 1rem;
    height: 1rem;
    fill: #1c7af5;
    margin-bottom: 0.2rem;
    margin-right: 0.2rem;
  }

  .btnAddLocal {
    background-color: white;
    color: #1c7af5;
    border-color: #1c7af5;
  }

  .btnAddLocal:hover {
    color: #1c7af5;
  }

  .mdLocalOcorrencia {
    &_body {
      border-bottom: pxToRem(1) solid $sinoreg-blue;
      margin: 0 pxToRem(20);
      margin-top: pxToRem(20);
      padding: 0;
    }

    &_footer {
      border: none;
    }

    .modal-footer {
      border: none;
    }
  }

  .btn-add-local:hover > [class*=icon-add] {
    fill: #fff !important;
  }
  .icon-add {
    fill: #1c7af5 !important;
    width: 16px;
    height: 16px;
    transition: fill 0.2s;
  }

</style>
